import Linkify from './src/Linkify';

export default Linkify;
